import React from 'react';
import { BedsBathBody } from './BedsBathBody';
import { useFilterController } from '../../../../application/useFilterController';

export const BedsBathDrawerSection = () => {
  const { bedsRange, bathsRange, setBedsRange, setBathsRange } = useFilterController();

  return (
    <div className="p-4">
      <BedsBathBody
        bedsRange={bedsRange}
        bathsRange={bathsRange}
        onBedsRangeChange={setBedsRange}
        onBathsRangeChange={setBathsRange}
      />
    </div>
  );
};
